import { Alert, Box, Grid, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ButtonCustomized from "../../../common/components/ButtonCustomized";
import TextFieldCustomized from "../../../common/components/TextFieldCustomized";
import { GO_BACK } from "../../../common/constants/routerConstants";
import { validateMotDePasse } from "../../../common/utils/validateUtils";
import {
  clearChangePasswordState,
  postChangePassword,
} from "../state/TiActions";

function ParametresDeCompte() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authReducer = useSelector((state) => state.authentificationReducer);
  const error = authReducer.passwordChangeError;
  const successMessage = authReducer.passwordChangeSuccessMassage;
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmNewPassword, setConfirmNewPassword] = useState("");
  const [errors, setErrors] = useState({});
  const [alertMessage, setAlertMessage] = useState(null);
  const [shouldNavigate, setShouldNavigate] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [severity, setSeverity] = useState(null);

  useEffect(() => {
    if (successMessage !== null) {
      setAlertMessage(successMessage);
      setShouldNavigate(true);
      setAlertOpen(true);
      setSeverity("success");
    } else if (error !== null) {
      setAlertMessage(error);
      setAlertOpen(true);
      setSeverity("error");
    }
  }, [error, successMessage]);

  const handleSubmit = (event) => {
    event.preventDefault();
    const { isValid, errors } = validateMotDePasse({
      currentPassword,
      newPassword,
      confirmNewPassword,
    });

    setErrors(errors);

    if (isValid) {
      let payload = {
        currentPassword: currentPassword,
        newPassword: newPassword,
        confirmNewPassword: confirmNewPassword,
      };
      dispatch(postChangePassword(payload));
    }
  };

  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    if (shouldNavigate === true) {
      navigate(GO_BACK);
      dispatch(clearChangePasswordState());
    } else {
      setTimeout(() => {
        dispatch(clearChangePasswordState());
      }, 2500);
    }
    setAlertOpen(false);
  };

  return (
    <Box>
      <Grid
        container
        justifyContent="center"
        alignItems="flex-start"
        style={{ marginTop: "50px" }}
      >
        <Grid item xs={12} sm={8} md={6} lg={4}>
          <TextFieldCustomized
            label="Mot de passe actuel"
            placeholder="Entrez votre mot de passe actuel"
            isPassword
            value={currentPassword}
            onChange={setCurrentPassword}
            error={errors.currentPassword}
            required
          />
          <TextFieldCustomized
            label="Nouveau mot de passe"
            placeholder="Entrez votre nouveau mot de passe"
            isPassword
            value={newPassword}
            onChange={setNewPassword}
            error={errors.newPassword}
            required
          />
          <TextFieldCustomized
            label="Confirmer le nouveau mot de passe"
            placeholder="Confirmez votre nouveau mot de passe"
            isPassword
            value={confirmNewPassword}
            onChange={setConfirmNewPassword}
            error={errors.confirmNewPassword}
            required
          />
          <Grid container justifyContent="flex-end" sx={{ mt: 2 }}>
            <ButtonCustomized
              title="Enregistrer"
              onClick={handleSubmit}
              variant="contained"
            />
          </Grid>
        </Grid>
      </Grid>
      <Box>
        <Snackbar
          open={alertOpen}
          autoHideDuration={2000}
          onClose={handleSnackClose}
        >
          <Alert
            onClose={handleSnackClose}
            severity={severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {alertMessage}
          </Alert>
        </Snackbar>
      </Box>
    </Box>
  );
}

export default ParametresDeCompte;
